import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ViveroService from "../../../../services/ViveroService";
import * as UserServices from "../../../../services/UserServices";

import { useTranslation } from "react-i18next";
import UserForm from "./userForm.view";
import PATHS from "../../../../constants/paths";
import {
  BreadCrumb,
  ShowAlertDialog,
} from "@de-prado-dev/react-component-library";

const UserFormContainer = ({ uuid, onCancel, onSuccess }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [viveros, setViveros] = useState([]);
  const [users, setUsers] = useState([]);
  const [checkCreate, setCheckCreate] = useState(false);

  const setInitialValues = useCallback(async (data, user) => {
    const dataFinal = {};
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    const resultViveros = await ViveroService.getAllViveros();
    if (resultViveros) {
      setViveros(resultViveros);
    }
    // await TaskService.listAllTask().then((result) => {
    //   setTasks(result);
    // });
    // if (uuid) {
    //   const result = await WorkingPartServices.getWorkingPart(uuid);
    //   if (result) {
    //     await setInitialValues(result, resultCode);
    //   }
    // }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;
        if (uuid) {
          // result = await UserServices.updateWorkingPart(values, uuid);
        } else {
          if (values.create) {
            result = await UserServices.createCoreUser(values);
          } else {
            result = await UserServices.addUser(values);
          }
        }
        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.workingPart.messages.update.title");
            text = t("forms.workingPart.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.workingPart.messages.create.title");
            text = t("forms.workingPart.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.workingPart.messages.update.error");
          icon = "error";
        }
        let okAction = () => {
          onSuccess();
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handlerFilterUser = async (value) => {
    const filter = {
      filters: {
        name: value,
      },
    };

    const result = await UserServices.listFilterCoreUser(filter);
    return result;
  };

  const handlerCheckCreate = (value) => {
    setCheckCreate(value);
  };

  return (
    <UserForm
      viveros={viveros}
      users={users}
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={onCancel}
      onFilterUser={handlerFilterUser}
      onCheckCreate={handlerCheckCreate}
      checkCreate={checkCreate}
    />
  );
};

UserFormContainer.propTypes = {
  t: PropTypes.any,
};

export default UserFormContainer;
